import { combineReducers } from "redux";
import authReducer from "./Auth.reducer";
import formReducer from "./Form.reducer";
import productReducer from "./Product.reducer";

const reducer = combineReducers({
  auth: authReducer,
  product: productReducer,
  form: formReducer,
});

export default reducer;
